import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTreePlus({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#F4F5FB" cx={10} cy={10} r={10} />
        <path
          d="M14.5 8.88h-3.38V5.5a.75.75 0 00-.74-.75h-.76a.75.75 0 00-.74.75v3.38H5.5a.75.75 0 00-.75.74v.76c0 .4.34.74.75.74h3.38v3.38c0 .41.33.75.74.75h.76c.4 0 .74-.34.74-.75v-3.38h3.38c.41 0 .75-.33.75-.74v-.76a.75.75 0 00-.75-.74z"
          fill="#4557A1"
        />
      </g>
    </svg>
  );
}

SvgTreePlus.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTreePlus.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgTreePlus svgRef={ref} {...props} />);
export default ForwardRef;
